import { Box, Form } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { Routes } from '../../../../../src/nav/routes'
import { RenderActionButtons } from './ActionButton'
import { formData } from './FormData'
import { styles } from './styles'

export const AddNewUserForm = ({ editData }: any) => {
  const [dropdownValue, updateDropdownValue] = useState('Choose role')
  const onDropdownValueChange = (value: string) => {
    updateDropdownValue(value)
  }

  const isEditScreen = editData?.passedData !== undefined
  const { passedData, mid, getJfsUserId } = editData

  const updateRoleWhileEditing = useCallback(() => updateDropdownValue(passedData?.department ?? ''), [passedData])

  useEffect(() => {
    if (passedData?.department) {
      updateRoleWhileEditing()
    }
  }, [passedData, updateRoleWhileEditing])

  const getFormData = (): any[] => {
    const initialFormData = [
      ...formData({
        dropdownValue: dropdownValue,
        onDropdownValueChange: onDropdownValueChange,
        accessRightsData: editData?.accessRightsData ?? [],
        isEditScreen: isEditScreen,
        hasSupersetPermission: editData?.hasSupersetPermission
      }),
    ]
    return initialFormData
  }

  return (
    <Form
      container={({ children }) => <Box {...styles.formBox}>{children}</Box>}
      formData={getFormData()}
      actionButtons={({ isValid, values }) => (
        <RenderActionButtons
          isEditScreen={isEditScreen}
          isValid={isValid}
          values={values}
          mid={mid}
          jfsUserId={getJfsUserId}
          previousFormData={{ ...passedData, accessRightsData: editData?.accessRightsData ?? [] }}
          screenName={Routes.SETTINGS}
        />
      )}
      initialValues={{
        userName: passedData?.name ?? '',
        mobile: passedData?.mobileNo ?? '',
        email: passedData?.email ?? '',
      }}
    />
  )
}
